import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Global } from '@services/core/Global';
import { QueryUtils } from 'app/core/utils/query.utils';

@Injectable({
  providedIn: 'root'
})
export class ReimbursementService {
  private http = inject(HttpClient);
  private url = Global.url + 'V1/reimbursements';

  constructor() { }

  // Obtiene el listado de reembolsos filtrado
  list(filters: any): Observable<any[]> {
    const params = QueryUtils.convertToFilter(filters);
    return this.http.get<any[]>(this.url, { params });
  }

  /** Pago desde bandeja de solicitudes (crea reembolso si falta). */
  payByRequest(requestUuid: string, transactionNumber: string, paidAt: string, file?: File, transferTarget: 'CAMPUS' | 'SOCIO' = 'CAMPUS'): Observable<any> {
    const formData = new FormData();
    formData.append('transactionNumber', transactionNumber);
    formData.append('paidAt', paidAt);
    formData.append('transferTarget', transferTarget);
    if (file) {
      formData.append('file', file);
    }
    return this.http.put(`${this.url}/by-request/${requestUuid}/pay`, formData);
  }

  /** Marca reembolsos pagados como contabilizados para no exportarlos dos veces. */
  markAccounted(uuids: string[]): Observable<any> {
    return this.http.put(`${this.url}/mark-accounted`, { uuids });
  }
}
